import { render, staticRenderFns } from "./fccEquipes.vue?vue&type=template&id=58678186"
import script from "./fccEquipes.vue?vue&type=script&lang=js"
export * from "./fccEquipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports